import sumBy from 'lodash/sumBy';
import { price as priceUtils } from '@eti/utils';
import { FAST_TRACK, LOUNGE } from '../../products';
import { AvailabilityType, getAvailabilityList } from '../../common/utils/availability';
import { climateCompensation } from '../../climate-compensation';
import { cancelForAnyReason } from '../../cancel-for-any-reason';
import { checkInBaggage } from '../../baggage-section/check-in-baggage';
import { flexibleTicket } from '../../flexible-ticket';
import { parseJsonProp } from '../../common/utils/productCardProps';
const {
  id: FAST_TRACK_ID
} = FAST_TRACK;
const {
  id: LOUNGE_ID
} = LOUNGE;
export const getIncludedProductPrice = (availableExtraProducts, selectedExtraProducts) => {
  return selectedExtraProducts.reduce((totalPrice, id) => {
    const selectedProduct = availableExtraProducts.find(product => product.productId === String(id));
    const sellSpecification = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.sellSpecification;
    let productTotalprice = 0;
    if (sellSpecification) {
      if (id === flexibleTicket.id) {
        const sellSpecificationTravelers = sellSpecification;
        const flexibleTicketPrices = sellSpecificationTravelers === null || sellSpecificationTravelers === void 0 ? void 0 : sellSpecificationTravelers.sellPriceTravelers;
        productTotalprice = sumBy(flexibleTicketPrices, 'price.price.value');
      } else if (id === checkInBaggage.id) {
        var _sellSpecificationBag;
        const sellSpecificationBaggage = sellSpecification;
        const checkInBaggageSellPriceBaggage = sellSpecificationBaggage === null || sellSpecificationBaggage === void 0 || (_sellSpecificationBag = sellSpecificationBaggage.sellPriceBaggage) === null || _sellSpecificationBag === void 0 ? void 0 : _sellSpecificationBag.flatMap(baggage => baggage === null || baggage === void 0 ? void 0 : baggage.options);
        productTotalprice = sumBy(checkInBaggageSellPriceBaggage, 'price.price.value');
      } else if (id === cancelForAnyReason.id) {
        const cfarTicketSellSpecification = sellSpecification;
        productTotalprice = sumBy([cfarTicketSellSpecification], 'price.price.value');
      } else if (id === climateCompensation.id) {
        const climateCompensationSellSpecification = sellSpecification;
        productTotalprice = sumBy([climateCompensationSellSpecification], 'price.price.value');
      }
    }
    return totalPrice + productTotalprice;
  }, 0);
};
const getAvailabilityType = productTypeId => {
  return productTypeId === FAST_TRACK_ID.toString() ? AvailabilityType.PerBound : AvailabilityType.PerSegment;
};
export const getAvailability = (bounds, productSpecificTexts, productTypeId) => {
  var _productSpecificTexts;
  const availabilityType = getAvailabilityType(productTypeId);
  const availabilityList = getAvailabilityList(bounds, (_productSpecificTexts = productSpecificTexts === null || productSpecificTexts === void 0 ? void 0 : productSpecificTexts.productSegmentAvailabilityTexts) !== null && _productSpecificTexts !== void 0 ? _productSpecificTexts : [], availabilityType);
  return availabilityList;
};
export const getPrice = availabilityProduct => {
  var _availabilityProduct$;
  const priceRaw = availabilityProduct && 'price' in availabilityProduct.sellSpecification ? availabilityProduct === null || availabilityProduct === void 0 || (_availabilityProduct$ = availabilityProduct.sellSpecification) === null || _availabilityProduct$ === void 0 || (_availabilityProduct$ = _availabilityProduct$.price) === null || _availabilityProduct$ === void 0 || (_availabilityProduct$ = _availabilityProduct$.price) === null || _availabilityProduct$ === void 0 ? void 0 : _availabilityProduct$.value : 0;
  const price = priceUtils.formatPrice(priceRaw);
  return {
    price,
    priceRaw
  };
};
export const getFastTrackProductdata = (availabilityList, translations, shouldDisplayUpsell, upSellObject) => {
  const {
    abstractContent,
    fasttrackAvailabilityCardAddedStatus,
    fasttrackAvailabilityCardAddedTitle,
    fasttrackAvailabilityCardAvailabilityTitle,
    fasttrackAvailabilityCardAvailableStatus,
    fasttrackAvailabilityCardDeparting,
    fasttrackAvailabilityCardReturn,
    fasttrackAvailabilityCardStatusTooltip,
    fasttrackAvailabilityCardUnavailableStatus,
    readMoreContent,
    title
  } = translations;
  const {
    additionalInformation
  } = translations !== null && translations !== void 0 ? translations : {
    additionalInformation: ''
  };
  const productId = Number(FAST_TRACK.id);
  const productName = FAST_TRACK.name;
  const illustrationUrl = '';
  const extraProps = {
    availabilityList,
    addedStatus: fasttrackAvailabilityCardAddedStatus,
    addedTitle: fasttrackAvailabilityCardAddedTitle,
    availabilityTitle: fasttrackAvailabilityCardAvailabilityTitle,
    availableStatus: fasttrackAvailabilityCardAvailableStatus,
    departingTitle: fasttrackAvailabilityCardDeparting,
    returnTitle: fasttrackAvailabilityCardReturn,
    statusTooltip: fasttrackAvailabilityCardStatusTooltip,
    unavailableStatus: fasttrackAvailabilityCardUnavailableStatus
  };
  return {
    additionalInformation,
    abstractContent,
    extraProps,
    illustrationUrl,
    productId,
    productName,
    readMoreContent,
    title,
    shouldDisplayUpsell,
    upSell: upSellObject
  };
};
export const getLoungeProductdata = (availabilityList, translations, shouldDisplayUpsell, upSellObject) => {
  const {
    abstractContent,
    loungeAvailabilityCardAddedStatus,
    loungeAvailabilityCardAddedTitle,
    loungeAvailabilityCardAvailabilityTitle,
    loungeAvailabilityCardAvailableStatus,
    loungeAvailabilityCardDeparting,
    loungeAvailabilityCardReturn,
    loungeAvailabilityCardSeeAll,
    loungeAvailabilityCardStatusTooltip,
    loungeAvailabilityCardUnavailableStatus,
    readMoreContent,
    title,
    loungeDrawerCondition,
    loungeDrawerLocation,
    loungeDrawerOpeningFrom,
    loungeDrawerOpeningTo,
    loungeDrawerOpeningTitle,
    loungeDrawerTerminal
  } = translations;
  const {
    additionalInformation
  } = translations !== null && translations !== void 0 ? translations : {
    additionalInformation: ''
  };
  const productId = Number(LOUNGE.id);
  const productName = LOUNGE.name;
  const illustrationUrl = '';
  const extraProps = {
    availabilityList,
    addedStatus: loungeAvailabilityCardAddedStatus,
    addedTitle: loungeAvailabilityCardAddedTitle,
    availabilityTitle: loungeAvailabilityCardAvailabilityTitle,
    availableStatus: loungeAvailabilityCardAvailableStatus,
    departingTitle: loungeAvailabilityCardDeparting,
    returnTitle: loungeAvailabilityCardReturn,
    seeAll: loungeAvailabilityCardSeeAll,
    statusTooltip: loungeAvailabilityCardStatusTooltip,
    unavailableStatus: loungeAvailabilityCardUnavailableStatus,
    condition: loungeDrawerCondition,
    location: loungeDrawerLocation,
    openingFrom: loungeDrawerOpeningFrom,
    openingTo: loungeDrawerOpeningTo,
    openingTitle: loungeDrawerOpeningTitle,
    terminal: loungeDrawerTerminal
  };
  return {
    additionalInformation,
    abstractContent,
    extraProps,
    illustrationUrl,
    productId,
    productName,
    readMoreContent,
    title,
    shouldDisplayUpsell,
    upSell: upSellObject
  };
};
export const getProductData = (availabilityList, translations, productTypeId, shouldDisplayAvailability, shouldDisplayUpsell, upSellObject) => {
  if (!shouldDisplayAvailability) {
    return undefined;
  }
  switch (productTypeId) {
    case FAST_TRACK_ID.toString():
      return getFastTrackProductdata(availabilityList, translations, shouldDisplayUpsell, upSellObject);
    case LOUNGE_ID.toString():
      return getLoungeProductdata(availabilityList, translations, shouldDisplayUpsell, upSellObject);
    default:
      return undefined;
  }
};
export const getProductdata = (availabilityList, name, productTypeId, translation, shouldDisplayUpsell, upSellObject) => {
  const {
    airportAvailability,
    abstractContent,
    readMoreContent,
    title
  } = translation;
  const {
    additionalInformation
  } = translation !== null && translation !== void 0 ? translation : {
    additionalInformation: ''
  };
  const availabilityProps = parseJsonProp(airportAvailability);
  const productId = Number(productTypeId);
  const productName = name;
  const illustrationUrl = '';
  const extraProps = {
    availabilityList,
    availabilityTranslation: availabilityProps
  };
  return {
    additionalInformation,
    airportAvailability,
    abstractContent,
    extraProps,
    illustrationUrl,
    productId,
    productName,
    readMoreContent,
    title,
    shouldDisplayUpsell,
    upSell: upSellObject
  };
};
const {
  formatPrice,
  getPriceDivided
} = priceUtils;
export const getFormattedPrice = (price, bounds, numberOfTravelersWithoutInfants, pricePerTravelerAndBound, pricePerTraveler) => {
  if (pricePerTravelerAndBound && bounds.length > 1) {
    const pricePerBound = price / bounds.length;
    return formatPrice(getPriceDivided(pricePerBound, numberOfTravelersWithoutInfants));
  }
  if (pricePerTraveler) {
    return formatPrice(getPriceDivided(price, numberOfTravelersWithoutInfants));
  }
  return formatPrice(price);
};
export const getAdditionalProductInfo = (t, product, bounds, piecesBaggageText, weightValuesBaggageText, whenAvailableText) => {
  const {
    pieces,
    productSpecificTexts,
    productTypeId,
    weight,
    weightUnit
  } = product;
  if (productSpecificTexts) {
    var _getAvailability;
    const availabilityList = (_getAvailability = getAvailability(bounds, productSpecificTexts, productTypeId)) !== null && _getAvailability !== void 0 ? _getAvailability : [];
    const hasUnavailable = availabilityList.some(airport => !airport.available);
    return hasUnavailable && whenAvailableText ? `(${whenAvailableText})` : null;
  }
  if (!(pieces && weight && weightUnit)) {
    return null;
  }
  return `${t(piecesBaggageText, pieces)} ${t(weightValuesBaggageText, weight, weightUnit)}`;
};
export const getPriceText = (bounds, pricePerTravelerAndBound, pricePerTraveler, totalPriceText, pricePerTravelerText, pricePerTravelerAndBoundText) => {
  if (pricePerTravelerAndBound && bounds.length > 1) {
    return pricePerTravelerAndBoundText;
  }
  if (pricePerTraveler) {
    return pricePerTravelerText;
  }
  return totalPriceText;
};
export const saveUpToAmountWithBundle = (options, percentage) => {
  const optionWithHighestPrice = options.reduce((max, item) => item.originalPrice > max.originalPrice ? item : max);
  const savedAmount = optionWithHighestPrice.originalPrice * percentage / 100;
  return priceUtils.formatPrice(savedAmount);
};
export const uniqueFeatures = sellableOptions => sellableOptions.reduce((acc, option) => {
  option.features.forEach(feature => {
    if (!acc.some(item => item.name === feature.name)) {
      acc.push(feature);
    }
  });
  return acc;
}, []);
const prioritiesMobile = {
  RECOMMENDED: 0,
  DELUXE: 1,
  PREMIUM: 2,
  BASIC: 3
};
export const mobileBundleOptionOrder = sellableOptions => [...sellableOptions].sort((a, b) => prioritiesMobile[a.type] - prioritiesMobile[b.type]);
//# sourceMappingURL=utils.js.map